export default (function scrollTopInit() {
    const scrollTop = {
        handler() {
            $('.js--scroll_top').on('click', (e) => {
                e.preventDefault();
                $('body, html').animate({ scrollTop: 0 }, '300');
            });
        },
        toggleButton() {
            const $el = $('.js--scroll_top');
            if ($(window).scrollTop() >= 200) {
                $el.addClass('show');
            } else {
                $el.removeClass('show');
            }
        },
    };
    $(document).ready(() => {
        scrollTop.handler();
        scrollTop.toggleButton();
    });
    $(window).scroll(() => {
        scrollTop.toggleButton();
    });
}());
